module.exports = __webpack_public_path__ + "img/graphical_upgrade_before.8957b89.png";